import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEmployeeData } from "./employeeSlice";
import useDebounce from "~/hooks/useDebounce";
import apiService from "~/services/service";
import API_ROUTES_V2 from "~/api-routes-v2";
import { useParams } from "react-router-dom";

const useEmploymentInformation = () => {
  const { id: entityId } = useParams();
  const dispatch = useDispatch();
  const [employeeId, setEmployeeId] = useState("");
  const [isIdAvailable, setIsIdAvailable] = useState(false);
  const hasHandledInitialEdit = useRef(false);
  const debouncedSearchTerm = useDebounce(employeeId, 200);

  const { activeIndex, employmentInformation } = useSelector(
    (state) => state.employeeregister,
  );

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, employmentInformation]);

  const handleEnableNext = () => {
    if (activeIndex === 2) {
      if (
        employmentInformation.employee_identifier &&
        employmentInformation.start_date &&
        employmentInformation.employment_status &&
        employmentInformation.currency &&
        employmentInformation.salary
      ) {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };

  const onChangeEmploymentInformation = (name, value) => {
    if (name === "employee_identifier") {
      hasHandledInitialEdit.current = true;
      setIsIdAvailable(false);
      setEmployeeId(value);
    }
    dispatch(
      setEmployeeData({
        key: "employmentInformation",
        value: { ...employmentInformation, [name]: value },
      }),
    );
  };
  const handleCheckEmployeeID = async (id) => {
    try {
      await apiService(API_ROUTES_V2.CHECK_EMPLOYEE_ID, "POST", {
        body: { employee_identifier: id },
        replace: { entityId },
      });
      setIsIdAvailable(false);
    } catch (error) {
      setIsIdAvailable(true);
    }
  };
  useEffect(() => {
    if (hasHandledInitialEdit.current && debouncedSearchTerm.length) {
      handleCheckEmployeeID(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);
  return {
    onChangeEmploymentInformation,
    employmentInformation,
    isIdAvailable,
  };
};

export default useEmploymentInformation;
